import type { AuditQuota } from '../types.ts'

export function formatDate(value: Date): string {
  return value.toISOString().slice(0, 10)
}

export function formatPeriod(from: Date, to: Date): string {
  return `${formatDate(from)} → ${formatDate(to)}`
}

/** Minor units to a money string in the audit's currency. */
export function formatAmount(minor: number, currency: string): string {
  const major = minor / 100
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(major)
  } catch {
    return `${major.toFixed(2)} ${currency}`
  }
}

/** `spent / quota` on the money axis, as a percent for the gauge. */
export function quotaPercent(spentAmount: number, quota: AuditQuota): number {
  if (quota.amount <= 0) return 0
  return Math.min(100, Math.round((spentAmount / quota.amount) * 100))
}

/** A `<input type="date">` value for a UTC date, and back. */
export function dateInputValue(value: Date | null | undefined): string {
  return value ? value.toISOString().slice(0, 10) : ''
}

export function dateFromInput(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
  const parsed = new Date(`${value}T00:00:00.000Z`)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}
